var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 6.28125V3.59375C25 2.11159 23.7666 0.90625 22.25 0.90625H4.375C2.10075 0.90625 0.25 2.71494 0.25 4.9375V21.0625C0.25 24.0201 2.71675 25.0938 4.375 25.0938H25C26.5166 25.0938 27.75 23.8884 27.75 22.4062V8.96875C27.75 7.48659 26.5166 6.28125 25 6.28125ZM22.25 18.375H19.5V13H22.25V18.375ZM4.375 6.28125C4.02097 6.26577 3.68668 6.11744 3.44175 5.86713C3.19683 5.61682 3.06013 5.28383 3.06013 4.9375C3.06013 4.59117 3.19683 4.25818 3.44175 4.00787C3.68668 3.75756 4.02097 3.60923 4.375 3.59375H22.25V6.28125H4.375Z",
    fill: "#90CAF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.c7ad9be3df5bc28126365e6b467d2a60.svg";
export { ForwardRef as ReactComponent };